import { FileText, Braces } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const download = async (roomId, format) => {
  try {
    const { data } = await api.get(`/rooms/${roomId}/transcript`, { params: { format }, responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `aurora-room-${roomId}-transcript.${format}`;
    a.click();
    URL.revokeObjectURL(url);
  } catch {
    toast.error("Transcript unavailable");
  }
};

export const TranscriptButtons = ({ roomId, compact = false }) => (
  <div className="flex gap-2" data-testid={`transcript-buttons-${roomId}`}>
    <button onClick={() => download(roomId, "txt")} className={`btn-ghost ${compact ? "!h-8 !px-2 text-[11px]" : ""}`} data-testid={`transcript-download-txt-${roomId}`}>
      <FileText size={14} /> {compact ? "TXT" : "Transcript .txt"}
    </button>
    <button onClick={() => download(roomId, "json")} className={`btn-ghost ${compact ? "!h-8 !px-2 text-[11px]" : ""}`} data-testid={`transcript-download-json-${roomId}`}>
      <Braces size={14} /> {compact ? "JSON" : ".json"}
    </button>
  </div>
);
